'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoDocumentText = function IoDocumentText(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm30.8 13.2c0.1 0.2 0.2 0.5 0.2 0.8v19.1c0 1-0.8 1.9-1.7 1.9h-19c-0.9 0-1.8-0.9-1.8-1.9v-26.2c0-1 0.9-1.9 1.8-1.9h12.5c0.2 0 0.5 0 0.7 0.2 0.2 0 0.4 0.2 0.5 0.3l6.6 7.2c0.2 0.2 0.2 0.3 0.2 0.5z m-18.5 0.8v0.8c0 0 0 0.2 0.2 0.2h5.5c0.2 0 0.3-0.2 0.3-0.2v-0.8c0-0.2-0.1-0.3-0.3-0.3h-5.5c-0.2 0-0.2 0.1-0.2 0.3z m0 10v0.8c0 0 0 0.2 0.2 0.2h9.6c0.1 0 0.1-0.2 0.1-0.2v-0.8c0-0.2 0-0.3-0.1-0.3h-9.6c-0.2 0-0.3 0.1-0.3 0.3z m12.5 5.8v-0.8c0-0.2 0-0.2-0.2-0.2h-12.1c-0.2 0-0.2 0-0.2 0.2v0.8c0 0 0 0.2 0.2 0.2h12.1c0.2 0 0.2-0.2 0.2-0.2z m2.5-10v-0.8c0-0.2 0-0.2-0.2-0.2h-14.6c-0.2 0-0.2 0-0.2 0.2v0.8c0 0 0 0.2 0.2 0.2h14.6c0.2 0 0.2-0.2 0.2-0.2z m-3.7-5.9h4.7l-5.6-6.1v5.2c0 0.4 0.4 0.9 0.9 0.9z' })
        )
    );
};

exports.default = IoDocumentText;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/document-text.js
// module id = 2008
// module chunks = 0